import { render, staticRenderFns } from "./Secured.vue?vue&type=template&id=743647da&scoped=true"
import script from "./Secured.vue?vue&type=script&lang=ts"
export * from "./Secured.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743647da",
  null
  
)

export default component.exports